import axios from 'axios'
import qs from 'qs'
import { MessageBox, Message } from 'element-ui'

const Qs = qs;
// create an axios instance
// console.log(process.env.VUE_APP_BASE_API)
const service = axios.create({
  baseURL: '', // url = base url + request url\
  timeout: 10000, // request timeout
  headers : {
    "Access-Control-Allow-Origin":"*",
    "Content-type":"application/x-www-form-urlencoded;charset=UTF-8"
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log(config)
    if(config.data){
      config.data = Qs.stringify(config.data)
    }
    if(config.params){
      // config.params = Qs.stringify(config.params)
      // config.headers = {
      //   "Access-Control-Allow-Origin":"*",
      //   "Content-type":"multipart/form-data"
      // }
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      if(res.code == 500){
        this.$message.error('网络繁忙，请稍后重试')
      }
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 10 * 1000
    })
    return Promise.reject(error)
  }
)

export default service